module.exports = __webpack_public_path__ + "static/hero-2-be974c93e9f75cd5a7fdf717aaf643d1.svg";